import { Injectable } from '@angular/core';
import {
  CanActivate,
} from '@angular/router';
import { AppState } from '@app/app-state';
import { select, Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { ClientStateStatus } from './client-state-status';
import { selectClientState } from './select-client-state';

@Injectable()
export class ClientStateGuard implements CanActivate {
  constructor(private store: Store<AppState>) {}

  canActivate() {
    return this.store.pipe(
      select(selectClientState),
      map((state) => state.status === ClientStateStatus.SuccessFullyLoaded),
      filter<boolean>(Boolean),
    );
  }
}
